const VERSION = "2.0.6";
export {
  VERSION
};
